import { render, staticRenderFns } from "./AppBtnGroup.vue?vue&type=template&id=41c9d168&"
var script = {}
import style0 from "./AppBtnGroup.vue?vue&type=style&index=0&id=41c9d168&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports